import { ComingSoon } from "@/components/comingSoon";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/openLibrary")({
  head: () => ({
    title: "Kütüphane | Alican Atalay ile Spor ve Koçluk",
    meta: [
      {
        name: "description",
        content:
          "Alican Atalay ile spor, koçluk ve kişisel gelişim alanında en güncel kaynaklar, kitaplar ve eğitim materyalleri. Sporcu gelişimi, antrenman programları, motivasyon, performans artırma ve sağlıklı yaşam için uzman içerikler. Alican Atalay'ın deneyimleriyle spor ve koçluk dünyasında öne çıkın.",
      },
      {
        name: "keywords",
        content:
          "Alican Atalay, spor koçluğu, spor, koçluk, antrenman, kişisel gelişim, motivasyon, performans, sporcu eğitimi, sağlıklı yaşam, spor kitapları, koçluk kaynakları, sporcu koçu, spor eğitimi, liderlik, spor psikolojisi, fitness, egzersiz, sporcu beslenmesi, başarı hikayeleri, sporcu motivasyonu",
      },
    ],
    links: [
      {
        rel: "icon",
        href: "https://atalaythecoach.com/favicon/favicon.svg",
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ComingSoon pageTitle="Kütüphane" />;
}
